import { defineMessages as i } from "react-intl";
const s = {
  ABOUT: "ABOUT",
  ACTIVITIES: "ACTIVITIES",
  AMBASSADOR_PROGRAM: "AMBASSADOR_PROGRAM",
  BLOG: "BLOG",
  CALIFORNIA_PRIVACY_LINK: "CALIFORNIA_PRIVACY",
  CAREERS: "CAREERS",
  COMMUNITY: "COMMUNITY",
  COMPANY: "COMPANY",
  COUNTRIES: "COUNTRIES",
  DOWNLOAD: "DOWNLOAD",
  EXPLORE: "EXPLORE",
  FOOTER_LOGO: "FOOTER_LOGO",
  HELP_CENTER: "HELP_CENTER",
  HOST: "HOST",
  LIST_YOUR_SPACE: "LIST_YOUR_SPACE",
  LOCATIONS: "LOCATIONS",
  PRESS: "PRESS",
  PRIVACY: "PRIVACY",
  REPORT_VULNERABILITY: "REPORT_VULNERABILITY",
  RESOURCES: "RESOURCES",
  SOCIAL: "SOCIAL",
  SUPPORT: "SUPPORT",
  TERMS: "TERMS",
  TRUST_AND_SAFETY: "TRUST_AND_SAFETY",
  YOUR_PRIVACY_CHOICES: "YOUR_PRIVACY_CHOICES"
}, O = i({
  [s.ABOUT]: {
    id: "shared_component.footer.about",
    defaultMessage: [{
      type: 0,
      value: "About"
    }]
  },
  [s.ACTIVITIES]: {
    id: "shared_component.footer.activities",
    defaultMessage: [{
      type: 0,
      value: "Activities"
    }]
  },
  [s.AMBASSADOR_PROGRAM]: {
    id: "shared_component.footer.ambassadors",
    defaultMessage: [{
      type: 0,
      value: "Ambassador Program"
    }]
  },
  [s.BLOG]: {
    id: "shared_component.footer.blog",
    defaultMessage: [{
      type: 0,
      value: "Blog"
    }]
  },
  [s.CALIFORNIA_PRIVACY_LINK]: {
    id: "shared_component.footer.california_privacy_link",
    defaultMessage: [{
      type: 0,
      value: "California Privacy"
    }]
  },
  [s.CAREERS]: {
    id: "shared_component.footer.careers",
    defaultMessage: [{
      type: 0,
      value: "Careers"
    }]
  },
  [s.COMMUNITY]: {
    id: "shared_component.footer.community",
    defaultMessage: [{
      type: 0,
      value: "Community"
    }]
  },
  [s.COMPANY]: {
    id: "shared_component.footer.company",
    defaultMessage: [{
      type: 0,
      value: "Company"
    }]
  },
  [s.COUNTRIES]: {
    id: "shared_component.footer.countries",
    defaultMessage: [{
      type: 0,
      value: "Countries"
    }]
  },
  [s.DOWNLOAD]: {
    id: "shared_component.footer.download",
    defaultMessage: [{
      type: 0,
      value: "Download"
    }]
  },
  [s.EXPLORE]: {
    id: "shared_component.footer.explore",
    defaultMessage: [{
      type: 0,
      value: "Explore"
    }]
  },
  [s.FOOTER_LOGO]: {
    id: "shared_component.footer.footer_logo",
    defaultMessage: [{
      type: 0,
      value: "Peerspace footer logo"
    }]
  },
  [s.HELP_CENTER]: {
    id: "shared_component.footer.help_center",
    defaultMessage: [{
      type: 0,
      value: "Help Center"
    }]
  },
  [s.HOST]: {
    id: "shared_component.footer.host",
    defaultMessage: [{
      type: 0,
      value: "Host"
    }]
  },
  [s.LIST_YOUR_SPACE]: {
    id: "shared_component.footer.list_your_space",
    defaultMessage: [{
      type: 0,
      value: "List your space"
    }]
  },
  [s.LOCATIONS]: {
    id: "shared_component.footer.locations",
    defaultMessage: [{
      type: 0,
      value: "Locations"
    }]
  },
  [s.PRESS]: {
    id: "shared_component.footer.press",
    defaultMessage: [{
      type: 0,
      value: "Press"
    }]
  },
  [s.PRIVACY]: {
    id: "shared_component.footer.privacy",
    defaultMessage: [{
      type: 0,
      value: "Privacy"
    }]
  },
  [s.REPORT_VULNERABILITY]: {
    id: "shared_component.footer.report_vulnerability",
    defaultMessage: [{
      type: 0,
      value: "Report Vulnerability"
    }]
  },
  [s.RESOURCES]: {
    id: "shared_component.footer.resources",
    defaultMessage: [{
      type: 0,
      value: "Resources"
    }]
  },
  [s.SOCIAL]: {
    id: "shared_component.footer.social",
    defaultMessage: [{
      type: 0,
      value: "Social"
    }]
  },
  [s.SUPPORT]: {
    id: "shared_component.footer.support",
    defaultMessage: [{
      type: 0,
      value: "Support"
    }]
  },
  [s.TERMS]: {
    id: "shared_component.footer.terms",
    defaultMessage: [{
      type: 0,
      value: "Terms"
    }]
  },
  [s.TRUST_AND_SAFETY]: {
    id: "shared_component.footer.trust_safety",
    defaultMessage: [{
      type: 0,
      value: "Trust and Safety"
    }]
  },
  [s.YOUR_PRIVACY_CHOICES]: {
    id: "shared_component.footer.your_privacy_choices",
    defaultMessage: [{
      type: 0,
      value: "Your privacy choices"
    }]
  }
}), _ = {
  BUTTON: "BUTTON",
  PRICE_SUMMARY: "PRICE_SUMMARY",
  FOOTER: "FOOTER",
  LOCALE_SELECTOR: "LOCALE_SELECTOR",
  NAVIGATION: "NAVIGATION",
  NAVBAR_BROWSE_PATHS: "NAVBAR_BROWSE_PATHS",
  NAVBAR_BROWSE_PATHS_ACTIVITIES: "NAVBAR_BROWSE_PATHS_ACTIVITIES",
  NAVBAR_BROWSE_PATHS_LOCATIONS: "NAVBAR_BROWSE_PATHS_LOCATIONS",
  NAVBAR_BROWSE_PATHS_IDEAS: "NAVBAR_BROWSE_PATHS_IDEAS",
  NAVBAR_BROWSE_PATHS_AMENITIES: "NAVBAR_BROWSE_PATHS_AMENITIES",
  NAVBAR_BROWSE_PATHS_SPACE_TYPES: "NAVBAR_BROWSE_PATHS_SPACE_TYPES",
  NAVBAR_BROWSE_PATHS_VENDORS: "NAVBAR_BROWSE_PATHS_VENDORS"
}, t = {
  BABY_SHOWER: "BABY_SHOWER",
  BIRTHDAY_PARTY: "BIRTHDAY_PARTY",
  BRIDAL_SHOWER: "BRIDAL_SHOWER",
  DINNER: "DINNER",
  FILM_SHOOT: "FILM_SHOOT",
  MEETING: "MEETING",
  PARTY: "PARTY",
  PHOTO_SHOOT: "PHOTO_SHOOT",
  RETREAT: "RETREAT",
  TRAINING: "TRAINING",
  VIDEO_SHOOT: "VIDEO_SHOOT",
  WEDDING: "WEDDING",
  WEDDING_RECEPTION: "WEDDING_RECEPTION",
  WORKSHOP: "WORKSHOP",
  SEE_ALL: "SEE_ALL"
}, v = i({
  [t.BABY_SHOWER]: {
    id: "navbar_browse_paths.activities.baby_shower",
    defaultMessage: [{
      type: 0,
      value: "Baby Shower"
    }]
  },
  [t.BIRTHDAY_PARTY]: {
    id: "navbar_browse_paths.activities.birthday_party",
    defaultMessage: [{
      type: 0,
      value: "Birthday Party"
    }]
  },
  [t.BRIDAL_SHOWER]: {
    id: "navbar_browse_paths.activities.bridal_shower",
    defaultMessage: [{
      type: 0,
      value: "Bridal Shower"
    }]
  },
  [t.DINNER]: {
    id: "navbar_browse_paths.activities.dinner",
    defaultMessage: [{
      type: 0,
      value: "Dinner"
    }]
  },
  [t.FILM_SHOOT]: {
    id: "navbar_browse_paths.activities.film_shoot",
    defaultMessage: [{
      type: 0,
      value: "Film Shoot"
    }]
  },
  [t.MEETING]: {
    id: "navbar_browse_paths.activities.meeting",
    defaultMessage: [{
      type: 0,
      value: "Meeting"
    }]
  },
  [t.PARTY]: {
    id: "navbar_browse_paths.activities.party",
    defaultMessage: [{
      type: 0,
      value: "Party"
    }]
  },
  [t.PHOTO_SHOOT]: {
    id: "navbar_browse_paths.activities.photo_shoot",
    defaultMessage: [{
      type: 0,
      value: "Photo Shoot"
    }]
  },
  [t.RETREAT]: {
    id: "navbar_browse_paths.activities.retreat",
    defaultMessage: [{
      type: 0,
      value: "Retreat"
    }]
  },
  [t.TRAINING]: {
    id: "navbar_browse_paths.activities.training",
    defaultMessage: [{
      type: 0,
      value: "Training"
    }]
  },
  [t.VIDEO_SHOOT]: {
    id: "navbar_browse_paths.activities.video_shoot",
    defaultMessage: [{
      type: 0,
      value: "Video Shoot"
    }]
  },
  [t.WEDDING]: {
    id: "navbar_browse_paths.activities.wedding",
    defaultMessage: [{
      type: 0,
      value: "Wedding"
    }]
  },
  [t.WEDDING_RECEPTION]: {
    id: "navbar_browse_paths.activities.wedding_reception",
    defaultMessage: [{
      type: 0,
      value: "Wedding Reception"
    }]
  },
  [t.WORKSHOP]: {
    id: "navbar_browse_paths.activities.workshop",
    defaultMessage: [{
      type: 0,
      value: "Workshop"
    }]
  },
  [t.SEE_ALL]: {
    id: "navbar_browse_paths.activities.see_all",
    defaultMessage: [{
      type: 0,
      value: "See all"
    }]
  }
}), o = {
  BATHTUB: "BATHTUB",
  CYCLORAMA: "CYCLORAMA",
  DECK: "DECK",
  FIRE_PIT: "FIRE_PIT",
  FIREPLACE: "FIREPLACE",
  GREEN_SCREEN: "GREEN_SCREEN",
  GRILL: "GRILL",
  KITCHEN: "KITCHEN",
  LOUNGE: "LOUNGE",
  PATIO: "PATIO",
  PIANO: "PIANO",
  POOL: "POOL",
  SEE_ALL: "SEE_ALL"
}, T = i({
  [o.BATHTUB]: {
    id: "navbar_browse_paths.amenities.bathtub",
    defaultMessage: [{
      type: 0,
      value: "Bathtub"
    }]
  },
  [o.CYCLORAMA]: {
    id: "navbar_browse_paths.amenities.cyclorama",
    defaultMessage: [{
      type: 0,
      value: "Cyclorama"
    }]
  },
  [o.DECK]: {
    id: "navbar_browse_paths.amenities.deck",
    defaultMessage: [{
      type: 0,
      value: "Deck"
    }]
  },
  [o.FIRE_PIT]: {
    id: "navbar_browse_paths.amenities.fire_pit",
    defaultMessage: [{
      type: 0,
      value: "Fire Pit"
    }]
  },
  [o.FIREPLACE]: {
    id: "navbar_browse_paths.amenities.fireplace",
    defaultMessage: [{
      type: 0,
      value: "Fireplace"
    }]
  },
  [o.GREEN_SCREEN]: {
    id: "navbar_browse_paths.amenities.green_screen",
    defaultMessage: [{
      type: 0,
      value: "Green Screen"
    }]
  },
  [o.GRILL]: {
    id: "navbar_browse_paths.amenities.grill",
    defaultMessage: [{
      type: 0,
      value: "Grill"
    }]
  },
  [o.KITCHEN]: {
    id: "navbar_browse_paths.amenities.kitchen",
    defaultMessage: [{
      type: 0,
      value: "Kitchen"
    }]
  },
  [o.LOUNGE]: {
    id: "navbar_browse_paths.amenities.lounge",
    defaultMessage: [{
      type: 0,
      value: "Lounge"
    }]
  },
  [o.PATIO]: {
    id: "navbar_browse_paths.amenities.patio",
    defaultMessage: [{
      type: 0,
      value: "Patio"
    }]
  },
  [o.PIANO]: {
    id: "navbar_browse_paths.amenities.piano",
    defaultMessage: [{
      type: 0,
      value: "Piano"
    }]
  },
  [o.POOL]: {
    id: "navbar_browse_paths.amenities.pool",
    defaultMessage: [{
      type: 0,
      value: "Pool"
    }]
  },
  [o.SEE_ALL]: {
    id: "navbar_browse_paths.amenities.see_all",
    defaultMessage: [{
      type: 0,
      value: "See all"
    }]
  }
}), e = {
  ARCUEIL: "ARCUEIL",
  ASNIERES_SUR_SEINE: "ASNIERES_SUR_SEINE",
  ATLANTA: "ATLANTA",
  AUSTIN: "AUSTIN",
  BAGNOLET: "BAGNOLET",
  BARCELONA: "BARCELONA",
  BERLIN: "BERLIN",
  BOULOGNE_BILLANCOURT: "BOULOGNE_BILLANCOURT",
  BRIGHTON_AND_HOVE: "BRIGHTON_AND_HOVE",
  BRISTOL: "BRISTOL",
  BROOKVALE: "BROOKVALE",
  CALGARY: "CALGARY",
  CHICAGO: "CHICAGO",
  COLOMBES: "COLOMBES",
  DALLAS: "DALLAS",
  EDINBURGH: "EDINBURGH",
  EDMONTON: "EDMONTON",
  ESSEX: "ESSEX",
  FITZROY: "FITZROY",
  FORT_ERIE: "FORT_ERIE",
  GLASGOW: "GLASGOW",
  GLEBE: "GLEBE",
  HOUSTON: "HOUSTON",
  ISSY_LES_MOULINEAUX: "ISSY_LES_MOULINEAUX",
  IVRY_SUR_SEINE: "IVRY_SUR_SEINE",
  LEICESTER: "LEICESTER",
  LONDON: "LONDON",
  LOS_ANGELES: "LOS_ANGELES",
  MALAKOFF: "MALAKOFF",
  MANCHESTER: "MANCHESTER",
  MELBOURNE: "MELBOURNE",
  MISSISSAUGA: "MISSISSAUGA",
  MONTREUIL: "MONTREUIL",
  NEUILLY_SUR_SEINE: "NEUILLY_SUR_SEINE",
  NEW_YORK: "NEW_YORK",
  NEWTOWN: "NEWTOWN",
  NORTH_SYDNEY: "NORTH_SYDNEY",
  NORTH_VANCOUVER: "NORTH_VANCOUVER",
  NOTTINGHAM: "NOTTINGHAM",
  PADDINGTON: "PADDINGTON",
  PANTIN: "PANTIN",
  PARIS: "PARIS",
  PHILADELPHIA: "PHILADELPHIA",
  RICHMOND: "RICHMOND",
  RICHMOND_HILL: "RICHMOND_HILL",
  SAINT_MAUR_DES_FOSSES: "SAINT_MAUR_DES_FOSSES",
  SAINT_OUEN: "SAINT_OUEN",
  SAN_DIEGO: "SAN_DIEGO",
  SAN_FRANCISCO: "SAN_FRANCISCO",
  SEATTLE: "SEATTLE",
  SOUTH_MELBOURNE: "SOUTH_MELBOURNE",
  ST_KILDA: "ST_KILDA",
  SURREY: "SURREY",
  SYDNEY: "SYDNEY",
  TORONTO: "TORONTO",
  VANCOUVER: "VANCOUVER",
  VAUGHAN: "VAUGHAN",
  VITRY_SUR_SEINE: "VITRY_SUR_SEINE",
  WASHINGTON_DC: "WASHINGTON_DC",
  WEST_MIDLANDS: "WEST_MIDLANDS",
  SEE_ALL: "SEE_ALL"
}, I = i({
  [e.ARCUEIL]: {
    id: "navbar_browse_paths.locations.arcueil",
    defaultMessage: [{
      type: 0,
      value: "Arcueil"
    }]
  },
  [e.ASNIERES_SUR_SEINE]: {
    id: "navbar_browse_paths.locations.asnières_sur_seine",
    defaultMessage: [{
      type: 0,
      value: "Asnières sur Seine"
    }]
  },
  [e.ATLANTA]: {
    id: "navbar_browse_paths.locations.atlanta",
    defaultMessage: [{
      type: 0,
      value: "Atlanta"
    }]
  },
  [e.AUSTIN]: {
    id: "navbar_browse_paths.locations.austin",
    defaultMessage: [{
      type: 0,
      value: "Austin"
    }]
  },
  [e.BAGNOLET]: {
    id: "navbar_browse_paths.locations.bagnolet",
    defaultMessage: [{
      type: 0,
      value: "Bagnolet"
    }]
  },
  [e.BARCELONA]: {
    id: "navbar_browse_paths.locations.barcelona",
    defaultMessage: [{
      type: 0,
      value: "Barcelona"
    }]
  },
  [e.BERLIN]: {
    id: "navbar_browse_paths.locations.berlin",
    defaultMessage: [{
      type: 0,
      value: "Berlin"
    }]
  },
  [e.BOULOGNE_BILLANCOURT]: {
    id: "navbar_browse_paths.locations.boulogne_billancourt",
    defaultMessage: [{
      type: 0,
      value: "Boulogne-Billancourt"
    }]
  },
  [e.BRIGHTON_AND_HOVE]: {
    id: "navbar_browse_paths.locations.brighton_and_hove",
    defaultMessage: [{
      type: 0,
      value: "Brighton and Hove"
    }]
  },
  [e.BRISTOL]: {
    id: "navbar_browse_paths.locations.bristol",
    defaultMessage: [{
      type: 0,
      value: "Bristol"
    }]
  },
  [e.BROOKVALE]: {
    id: "navbar_browse_paths.locations.brookvale",
    defaultMessage: [{
      type: 0,
      value: "Brookvale"
    }]
  },
  [e.CALGARY]: {
    id: "navbar_browse_paths.locations.calgary",
    defaultMessage: [{
      type: 0,
      value: "Calgary"
    }]
  },
  [e.CHICAGO]: {
    id: "navbar_browse_paths.locations.chicago",
    defaultMessage: [{
      type: 0,
      value: "Chicago"
    }]
  },
  [e.COLOMBES]: {
    id: "navbar_browse_paths.locations.colombes",
    defaultMessage: [{
      type: 0,
      value: "Colombes"
    }]
  },
  [e.DALLAS]: {
    id: "navbar_browse_paths.locations.dallas",
    defaultMessage: [{
      type: 0,
      value: "Dallas"
    }]
  },
  [e.EDINBURGH]: {
    id: "navbar_browse_paths.locations.edinburgh",
    defaultMessage: [{
      type: 0,
      value: "Edinburgh"
    }]
  },
  [e.EDMONTON]: {
    id: "navbar_browse_paths.locations.edmonton",
    defaultMessage: [{
      type: 0,
      value: "Edmonton"
    }]
  },
  [e.ESSEX]: {
    id: "navbar_browse_paths.locations.essex",
    defaultMessage: [{
      type: 0,
      value: "Essex"
    }]
  },
  [e.FITZROY]: {
    id: "navbar_browse_paths.locations.fitzroy",
    defaultMessage: [{
      type: 0,
      value: "Fitzroy"
    }]
  },
  [e.FORT_ERIE]: {
    id: "navbar_browse_paths.locations.fort_erie",
    defaultMessage: [{
      type: 0,
      value: "Fort Erie"
    }]
  },
  [e.GLASGOW]: {
    id: "navbar_browse_paths.locations.glasgow",
    defaultMessage: [{
      type: 0,
      value: "Glasgow"
    }]
  },
  [e.GLEBE]: {
    id: "navbar_browse_paths.locations.glebe",
    defaultMessage: [{
      type: 0,
      value: "Glebe"
    }]
  },
  [e.HOUSTON]: {
    id: "navbar_browse_paths.locations.houston",
    defaultMessage: [{
      type: 0,
      value: "Houston"
    }]
  },
  [e.ISSY_LES_MOULINEAUX]: {
    id: "navbar_browse_paths.locations.issy_les_moulineaux",
    defaultMessage: [{
      type: 0,
      value: "Issy Les Moulineaux"
    }]
  },
  [e.IVRY_SUR_SEINE]: {
    id: "navbar_browse_paths.locations.ivry_sur_seine",
    defaultMessage: [{
      type: 0,
      value: "Ivry-sur-Seine"
    }]
  },
  [e.LEICESTER]: {
    id: "navbar_browse_paths.locations.leicester",
    defaultMessage: [{
      type: 0,
      value: "Leicester"
    }]
  },
  [e.LONDON]: {
    id: "navbar_browse_paths.locations.london",
    defaultMessage: [{
      type: 0,
      value: "London"
    }]
  },
  [e.LOS_ANGELES]: {
    id: "navbar_browse_paths.locations.los_angeles",
    defaultMessage: [{
      type: 0,
      value: "Los Angeles"
    }]
  },
  [e.MALAKOFF]: {
    id: "navbar_browse_paths.locations.malakoff",
    defaultMessage: [{
      type: 0,
      value: "Malakoff"
    }]
  },
  [e.MANCHESTER]: {
    id: "navbar_browse_paths.locations.manchester",
    defaultMessage: [{
      type: 0,
      value: "Manchester"
    }]
  },
  [e.MELBOURNE]: {
    id: "navbar_browse_paths.locations.melbourne",
    defaultMessage: [{
      type: 0,
      value: "Melbourne"
    }]
  },
  [e.MISSISSAUGA]: {
    id: "navbar_browse_paths.locations.mississauga",
    defaultMessage: [{
      type: 0,
      value: "Mississauga"
    }]
  },
  [e.MONTREUIL]: {
    id: "navbar_browse_paths.locations.montreuil",
    defaultMessage: [{
      type: 0,
      value: "Montreuil"
    }]
  },
  [e.NEUILLY_SUR_SEINE]: {
    id: "navbar_browse_paths.locations.neuilly_sur_seine",
    defaultMessage: [{
      type: 0,
      value: "Neuilly-Sur-Seine"
    }]
  },
  [e.NEW_YORK]: {
    id: "navbar_browse_paths.locations.new_york",
    defaultMessage: [{
      type: 0,
      value: "New York"
    }]
  },
  [e.NEWTOWN]: {
    id: "navbar_browse_paths.locations.newtown",
    defaultMessage: [{
      type: 0,
      value: "Newtown"
    }]
  },
  [e.NORTH_SYDNEY]: {
    id: "navbar_browse_paths.locations.north_sydney",
    defaultMessage: [{
      type: 0,
      value: "North Sydney"
    }]
  },
  [e.NORTH_VANCOUVER]: {
    id: "navbar_browse_paths.locations.north_vancouver",
    defaultMessage: [{
      type: 0,
      value: "North Vancouver"
    }]
  },
  [e.NOTTINGHAM]: {
    id: "navbar_browse_paths.locations.nottingham",
    defaultMessage: [{
      type: 0,
      value: "Nottingham"
    }]
  },
  [e.PADDINGTON]: {
    id: "navbar_browse_paths.locations.paddington",
    defaultMessage: [{
      type: 0,
      value: "Paddington"
    }]
  },
  [e.PANTIN]: {
    id: "navbar_browse_paths.locations.pantin",
    defaultMessage: [{
      type: 0,
      value: "Pantin"
    }]
  },
  [e.PARIS]: {
    id: "navbar_browse_paths.locations.paris",
    defaultMessage: [{
      type: 0,
      value: "Paris"
    }]
  },
  [e.PHILADELPHIA]: {
    id: "navbar_browse_paths.locations.philadelphia",
    defaultMessage: [{
      type: 0,
      value: "Philadelphia"
    }]
  },
  [e.RICHMOND]: {
    id: "navbar_browse_paths.locations.richmond",
    defaultMessage: [{
      type: 0,
      value: "Richmond"
    }]
  },
  [e.RICHMOND_HILL]: {
    id: "navbar_browse_paths.locations.richmond_hill",
    defaultMessage: [{
      type: 0,
      value: "Richmond Hill"
    }]
  },
  [e.SAINT_MAUR_DES_FOSSES]: {
    id: "navbar_browse_paths.locations.saint_maur_des_fossés",
    defaultMessage: [{
      type: 0,
      value: "Saint-Maur-des-Fossés"
    }]
  },
  [e.SAINT_OUEN]: {
    id: "navbar_browse_paths.locations.saint_ouen",
    defaultMessage: [{
      type: 0,
      value: "Saint Ouen"
    }]
  },
  [e.SAN_DIEGO]: {
    id: "navbar_browse_paths.locations.san_diego",
    defaultMessage: [{
      type: 0,
      value: "San Diego"
    }]
  },
  [e.SAN_FRANCISCO]: {
    id: "navbar_browse_paths.locations.san_francisco",
    defaultMessage: [{
      type: 0,
      value: "San Francisco"
    }]
  },
  [e.SEATTLE]: {
    id: "navbar_browse_paths.locations.seattle",
    defaultMessage: [{
      type: 0,
      value: "Seattle"
    }]
  },
  [e.SOUTH_MELBOURNE]: {
    id: "navbar_browse_paths.locations.south_melbourne",
    defaultMessage: [{
      type: 0,
      value: "South Melbourne"
    }]
  },
  [e.ST_KILDA]: {
    id: "navbar_browse_paths.locations.st_kilda",
    defaultMessage: [{
      type: 0,
      value: "St Kilda"
    }]
  },
  [e.SURREY]: {
    id: "navbar_browse_paths.locations.surrey",
    defaultMessage: [{
      type: 0,
      value: "Surrey"
    }]
  },
  [e.SYDNEY]: {
    id: "navbar_browse_paths.locations.sydney",
    defaultMessage: [{
      type: 0,
      value: "Sydney"
    }]
  },
  [e.TORONTO]: {
    id: "navbar_browse_paths.locations.toronto",
    defaultMessage: [{
      type: 0,
      value: "Toronto"
    }]
  },
  [e.VANCOUVER]: {
    id: "navbar_browse_paths.locations.vancouver",
    defaultMessage: [{
      type: 0,
      value: "Vancouver"
    }]
  },
  [e.VAUGHAN]: {
    id: "navbar_browse_paths.locations.vaughan",
    defaultMessage: [{
      type: 0,
      value: "Vaughan"
    }]
  },
  [e.VITRY_SUR_SEINE]: {
    id: "navbar_browse_paths.locations.vitry_sur_seine",
    defaultMessage: [{
      type: 0,
      value: "Vitry-sur-Seine"
    }]
  },
  [e.WASHINGTON_DC]: {
    id: "navbar_browse_paths.locations.washington_dc",
    defaultMessage: [{
      type: 0,
      value: "Washington D.C."
    }]
  },
  [e.WEST_MIDLANDS]: {
    id: "navbar_browse_paths.locations.west_midlands",
    defaultMessage: [{
      type: 0,
      value: "West Midlands"
    }]
  },
  [e.SEE_ALL]: {
    id: "navbar_browse_paths.locations.see_all",
    defaultMessage: [{
      type: 0,
      value: "See all"
    }]
  }
}), l = {
  BABY_SHOWER_IDEAS: "BABY_SHOWER_IDEAS",
  BIRTHDAY_PHOTOSHOOT_IDEAS: "BIRTHDAY_PHOTOSHOOT_IDEAS",
  BLACK_AND_WHITE_PHOTOSHOOT_IDEAS: "BLACK_AND_WHITE_PHOTOSHOOT_IDEAS",
  BOUDOIR_PHOTOSHOOT_IDEAS: "BOUDOIR_PHOTOSHOOT_IDEAS",
  BRIDAL_SHOWER_IDEAS: "BRIDAL_SHOWER_IDEAS",
  COUPLES_PHOTOSHOOT_IDEAS: "COUPLES_PHOTOSHOOT_IDEAS",
  OUTDOOR_PHOTOSHOOT_IDEAS: "OUTDOOR_PHOTOSHOOT_IDEAS",
  PARTY_IDEAS: "PARTY_IDEAS",
  PHOTOSHOOT_IDEAS: "PHOTOSHOOT_IDEAS",
  PINK_PHOTOSHOOT_IDEAS: "PINK_PHOTOSHOOT_IDEAS",
  SPRING_PHOTOSHOOT_IDEAS: "SPRING_PHOTOSHOOT_IDEAS",
  SUMMER_PHOTOSHOOT_IDEAS: "SUMMER_PHOTOSHOOT_IDEAS",
  SEE_ALL: "SEE_ALL"
}, R = i({
  [l.BABY_SHOWER_IDEAS]: {
    id: "navbar_browse_paths.ideas.baby_shower_ideas",
    defaultMessage: [{
      type: 0,
      value: "Baby shower ideas"
    }]
  },
  [l.BIRTHDAY_PHOTOSHOOT_IDEAS]: {
    id: "navbar_browse_paths.ideas.birthday_photoshoot_ideas",
    defaultMessage: [{
      type: 0,
      value: "Birthday photoshoot ideas"
    }]
  },
  [l.BLACK_AND_WHITE_PHOTOSHOOT_IDEAS]: {
    id: "navbar_browse_paths.ideas.black_and_white_photoshoot_ideas",
    defaultMessage: [{
      type: 0,
      value: "Black and white photoshoot ideas"
    }]
  },
  [l.BOUDOIR_PHOTOSHOOT_IDEAS]: {
    id: "navbar_browse_paths.ideas.boudoir_photoshoot_ideas",
    defaultMessage: [{
      type: 0,
      value: "Boudoir photoshoot ideas"
    }]
  },
  [l.BRIDAL_SHOWER_IDEAS]: {
    id: "navbar_browse_paths.ideas.bridal_shower_ideas",
    defaultMessage: [{
      type: 0,
      value: "Bridal shower ideas"
    }]
  },
  [l.COUPLES_PHOTOSHOOT_IDEAS]: {
    id: "navbar_browse_paths.ideas.couples_photoshoot_ideas",
    defaultMessage: [{
      type: 0,
      value: "Couples photoshoot ideas"
    }]
  },
  [l.OUTDOOR_PHOTOSHOOT_IDEAS]: {
    id: "navbar_browse_paths.ideas.outdoor_photoshoot_ideas",
    defaultMessage: [{
      type: 0,
      value: "Outdoor photoshoot ideas"
    }]
  },
  [l.PARTY_IDEAS]: {
    id: "navbar_browse_paths.ideas.party_ideas",
    defaultMessage: [{
      type: 0,
      value: "Party ideas"
    }]
  },
  [l.PHOTOSHOOT_IDEAS]: {
    id: "navbar_browse_paths.ideas.photoshoot_ideas",
    defaultMessage: [{
      type: 0,
      value: "Photoshoot ideas"
    }]
  },
  [l.PINK_PHOTOSHOOT_IDEAS]: {
    id: "navbar_browse_paths.ideas.pink_photoshoot_ideas",
    defaultMessage: [{
      type: 0,
      value: "Pink photoshoot ideas"
    }]
  },
  [l.SPRING_PHOTOSHOOT_IDEAS]: {
    id: "navbar_browse_paths.ideas.spring_photoshoot_ideas",
    defaultMessage: [{
      type: 0,
      value: "Spring photoshoot ideas"
    }]
  },
  [l.SUMMER_PHOTOSHOOT_IDEAS]: {
    id: "navbar_browse_paths.ideas.summer_photoshoot_ideas",
    defaultMessage: [{
      type: 0,
      value: "Summer photoshoot ideas"
    }]
  },
  [l.SEE_ALL]: {
    id: "navbar_browse_paths.ideas.see_all",
    defaultMessage: [{
      type: 0,
      value: "See all"
    }]
  }
}), d = {
  BAR_SERVICES_AND_BEVERAGES: "BAR_SERVICES_AND_BEVERAGES",
  CATERERS_AND_PRIVATE_CHEFS: "CATERERS_AND_PRIVATE_CHEFS",
  LIVE_MUSICIANS_AND_DJS: "LIVE_MUSICIANS_AND_DJS",
  PHOTOGRAPHERS: "PHOTOGRAPHERS",
  SEE_ALL: "SEE_ALL"
}, N = i({
  [d.BAR_SERVICES_AND_BEVERAGES]: {
    id: "navbar_browse_paths.vendors.bar_services_and_beverages",
    defaultMessage: [{
      type: 0,
      value: "Bar services & beverages"
    }]
  },
  [d.CATERERS_AND_PRIVATE_CHEFS]: {
    id: "navbar_browse_paths.vendors.caterers_and_private_chefs",
    defaultMessage: [{
      type: 0,
      value: "Caterers & private chefs"
    }]
  },
  [d.LIVE_MUSICIANS_AND_DJS]: {
    id: "navbar_browse_paths.vendors.live_musicians_and_djs",
    defaultMessage: [{
      type: 0,
      value: "Live musicians & DJs"
    }]
  },
  [d.PHOTOGRAPHERS]: {
    id: "navbar_browse_paths.vendors.photographers",
    defaultMessage: [{
      type: 0,
      value: "Photographers"
    }]
  },
  [d.SEE_ALL]: {
    id: "navbar_browse_paths.vendors.see_all",
    defaultMessage: [{
      type: 0,
      value: "See all"
    }]
  }
}), r = {
  BAR: "BAR",
  BARN: "BARN",
  BASKETBALL_COURT: "BASKETBALL_COURT",
  CABIN: "CABIN",
  CASTLE: "CASTLE",
  COMMERCIAL_KITCHEN: "COMMERCIAL_KITCHEN",
  COMMUNITY_CENTER: "COMMUNITY_CENTER",
  GARAGE: "GARAGE",
  HOUSE: "HOUSE",
  MANSION: "MANSION",
  MOVIE_THEATER: "MOVIE_THEATER",
  WAREHOUSE: "WAREHOUSE"
}, c = i({
  [r.BAR]: {
    id: "navbar_browse_paths.space_types.bar",
    defaultMessage: [{
      type: 0,
      value: "Bar"
    }]
  },
  [r.BARN]: {
    id: "navbar_browse_paths.space_types.barn",
    defaultMessage: [{
      type: 0,
      value: "Barn"
    }]
  },
  [r.BASKETBALL_COURT]: {
    id: "navbar_browse_paths.space_types.basketball-court",
    defaultMessage: [{
      type: 0,
      value: "Basketball Court"
    }]
  },
  [r.CABIN]: {
    id: "navbar_browse_paths.space_types.cabin",
    defaultMessage: [{
      type: 0,
      value: "Cabin"
    }]
  },
  [r.CASTLE]: {
    id: "navbar_browse_paths.space_types.castle",
    defaultMessage: [{
      type: 0,
      value: "Castle"
    }]
  },
  [r.COMMERCIAL_KITCHEN]: {
    id: "navbar_browse_paths.space_types.commercial_kitchen",
    defaultMessage: [{
      type: 0,
      value: "Commercial Kitchen"
    }]
  },
  [r.COMMUNITY_CENTER]: {
    id: "navbar_browse_paths.space_types.community_center",
    defaultMessage: [{
      type: 0,
      value: "Community Center"
    }]
  },
  [r.GARAGE]: {
    id: "navbar_browse_paths.space_types.garage",
    defaultMessage: [{
      type: 0,
      value: "Garage"
    }]
  },
  [r.HOUSE]: {
    id: "navbar_browse_paths.space_types.house",
    defaultMessage: [{
      type: 0,
      value: "House"
    }]
  },
  [r.MANSION]: {
    id: "navbar_browse_paths.space_types.mansion",
    defaultMessage: [{
      type: 0,
      value: "Mansion"
    }]
  },
  [r.MOVIE_THEATER]: {
    id: "navbar_browse_paths.space_types.movie_theater",
    defaultMessage: [{
      type: 0,
      value: "Movie Theater"
    }]
  },
  [r.WAREHOUSE]: {
    id: "navbar_browse_paths.space_types.warehouse",
    defaultMessage: [{
      type: 0,
      value: "Warehouse"
    }]
  }
}), n = {
  ACTIVITIES: "ACTIVITIES",
  AMENITIES: "AMENITIES",
  LOCATIONS: "LOCATIONS",
  IDEAS: "IDEAS",
  SPACE_TYPES: "SPACE_TYPES",
  VENDORS: "VENDORS",
  SEE_ALL: "SEE_ALL"
}, M = i({
  [n.ACTIVITIES]: {
    id: "navbar_browse_paths.activities",
    defaultMessage: [{
      type: 0,
      value: "Activities"
    }]
  },
  [n.AMENITIES]: {
    id: "navbar_browse_paths.amenities",
    defaultMessage: [{
      type: 0,
      value: "Amenities"
    }]
  },
  [n.LOCATIONS]: {
    id: "navbar_browse_paths.locations",
    defaultMessage: [{
      type: 0,
      value: "Locations"
    }]
  },
  [n.IDEAS]: {
    id: "navbar_browse_paths.ideas",
    defaultMessage: [{
      type: 0,
      value: "Ideas"
    }]
  },
  [n.SPACE_TYPES]: {
    id: "navbar_browse_paths.space_types",
    defaultMessage: [{
      type: 0,
      value: "Space Types"
    }]
  },
  [n.VENDORS]: {
    id: "navbar_browse_paths.vendors",
    defaultMessage: [{
      type: 0,
      value: "Vendors"
    }]
  },
  [n.SEE_ALL]: {
    id: "navbar_browse_paths.activities.see_all",
    defaultMessage: [{
      type: 0,
      value: "See all"
    }]
  }
}), a = {
  ADD_ONS: "ADD_ONS",
  ADD_PAYOUT: "ADD_PAYOUT",
  ADD_SPACE: "ADD_SPACE",
  BOARDS: "BOARDS",
  BOOKINGS: "BOOKINGS",
  BROWSE_SPACES_NAV_ITEM: "BROWSE_SPACES_NAV_ITEM",
  CALENDAR: "CALENDAR",
  COMMUNITY: "COMMUNITY",
  EARN_50: "EARN_50",
  EARN_50_ALT: "EARN_50_ALT",
  HELP: "HELP",
  HOST_HUB: "HOST_HUB",
  INBOX: "INBOX",
  LIST_SPACE: "LIST_SPACE",
  LISTINGS: "LISTINGS",
  LOGIN: "LOGIN",
  LOGO_ALT: "LOGO_ALT",
  LOGOUT: "LOGOUT",
  NEW: "NEW",
  PAYMENTS: "PAYMENTS",
  PAYOUT_BLOCKED: "PAYOUT_BLOCKED",
  PROFILE: "PROFILE",
  REVIEWS: "REVIEWS",
  SEARCH: "SEARCH",
  SIGNUP: "SIGNUP",
  TOGGLE_NAV: "TOGGLE_NAV"
}, y = i({
  [a.ADD_ONS]: {
    id: "shared_component.nav.add_ons",
    defaultMessage: [{
      type: 0,
      value: "Add-ons"
    }]
  },
  [a.ADD_PAYOUT]: {
    id: "shared_component.nav.add_payout",
    defaultMessage: [{
      type: 0,
      value: "Add Payout Info"
    }]
  },
  [a.ADD_SPACE]: {
    id: "shared_component.nav.add_space",
    defaultMessage: [{
      type: 0,
      value: "Add a Space"
    }]
  },
  [a.BOARDS]: {
    id: "shared_component.nav.boards",
    defaultMessage: [{
      type: 0,
      value: "Boards"
    }]
  },
  [a.BOOKINGS]: {
    id: "shared_component.nav.bookings",
    defaultMessage: [{
      type: 0,
      value: "Bookings"
    }]
  },
  [a.CALENDAR]: {
    id: "shared_component.nav.calendar",
    defaultMessage: [{
      type: 0,
      value: "Calendar"
    }]
  },
  [a.COMMUNITY]: {
    id: "shared_component.nav.community",
    defaultMessage: [{
      type: 0,
      value: "Community"
    }]
  },
  [a.EARN_50]: {
    id: "shared_component.nav.earn_50",
    defaultMessage: [{
      type: 0,
      value: "Earn $50"
    }]
  },
  [a.EARN_50_ALT]: {
    id: "shared_component.nav.earn_50_alt",
    defaultMessage: [{
      type: 0,
      value: "gift"
    }]
  },
  [a.HELP]: {
    id: "shared_component.nav.help",
    defaultMessage: [{
      type: 0,
      value: "Help"
    }]
  },
  [a.HOST_HUB]: {
    id: "shared_component.navbar.host_hub_nav_item",
    defaultMessage: [{
      type: 0,
      value: "Host hub"
    }]
  },
  [a.INBOX]: {
    id: "shared_component.nav.inbox",
    defaultMessage: [{
      type: 0,
      value: "Inbox"
    }]
  },
  [a.LIST_SPACE]: {
    id: "shared_component.nav.list_space",
    defaultMessage: [{
      type: 0,
      value: "List Your Space"
    }]
  },
  [a.LISTINGS]: {
    id: "shared_component.nav.listings",
    defaultMessage: [{
      type: 0,
      value: "Listings"
    }]
  },
  [a.LOGIN]: {
    id: "shared_component.nav.login",
    defaultMessage: [{
      type: 0,
      value: "Log In"
    }]
  },
  [a.LOGO_ALT]: {
    id: "shared_component.nav.logo_alt",
    defaultMessage: [{
      type: 0,
      value: "Peerspace | Unique venues for meetings, events, photo & film shoots"
    }]
  },
  [a.LOGOUT]: {
    id: "shared_component.nav.logout",
    defaultMessage: [{
      type: 0,
      value: "Log Out"
    }]
  },
  [a.NEW]: {
    id: "shared_component.nav.new",
    defaultMessage: [{
      type: 0,
      value: "NEW!"
    }]
  },
  [a.PAYMENTS]: {
    id: "shared_component.nav.payments",
    defaultMessage: [{
      type: 0,
      value: "Payments"
    }]
  },
  [a.PAYOUT_BLOCKED]: {
    id: "shared_component.nav.payout_blocked",
    defaultMessage: [{
      type: 0,
      value: "Payouts Blocked"
    }]
  },
  [a.PROFILE]: {
    id: "shared_component.nav.profile",
    defaultMessage: [{
      type: 0,
      value: "Profile"
    }]
  },
  [a.REVIEWS]: {
    id: "shared_component.nav.reviews",
    defaultMessage: [{
      type: 0,
      value: "Reviews"
    }]
  },
  [a.SEARCH]: {
    id: "shared_component.nav.search",
    defaultMessage: [{
      type: 0,
      value: "Search"
    }]
  },
  [a.SIGNUP]: {
    id: "shared_component.nav.signup",
    defaultMessage: [{
      type: 0,
      value: "Sign Up"
    }]
  },
  [a.TOGGLE_NAV]: {
    id: "shared_component.nav.toggle_nav",
    defaultMessage: [{
      type: 0,
      value: "Toggle navigation"
    }]
  },
  [a.BROWSE_SPACES_NAV_ITEM]: {
    id: "shared_component.navbar.browse_spaces_nav_item",
    defaultMessage: [{
      type: 0,
      value: "Browse Spaces"
    }]
  }
}), b = (E) => Object.values(_).includes(E), f = (E, u) => {
  if (!b(E))
    throw new Error(`Invalid namespace: ${E}. Must be one of: ${Object.values(_).join(", ")}`);
  return {
    formatComponentMessage: (S, A = {}) => {
      const p = h[E][S];
      return u.formatMessage(p, A);
    }
  };
}, h = {
  [_.PRICE_SUMMARY]: i({
    price_details: {
      id: "price_summary.price_details",
      defaultMessage: [{
        type: 0,
        value: "Price details"
      }]
    },
    hours_label: {
      id: "price_summary.hours_label",
      defaultMessage: [{
        type: 6,
        value: "numberOfHours",
        options: {
          one: {
            value: [{
              type: 7
            }, {
              type: 0,
              value: " hour"
            }]
          },
          other: {
            value: [{
              type: 7
            }, {
              type: 0,
              value: " hours"
            }]
          }
        },
        offset: 0,
        pluralType: "cardinal"
      }]
    },
    hourly_price: {
      id: "price_summary.hourly_price",
      defaultMessage: [{
        type: 0,
        value: "Hourly price"
      }]
    },
    cleaning_fee: {
      id: "price_summary.cleaning_fee",
      defaultMessage: [{
        type: 0,
        value: "Cleaning fee"
      }]
    },
    discount_hourly: {
      id: "price_summary.discount_hourly",
      defaultMessage: [{
        type: 0,
        value: "Hourly discount (8+ hrs)"
      }]
    },
    discount_total_price: {
      id: "price_summary.discount_total_price",
      defaultMessage: [{
        type: 0,
        value: "8+ hour discount ("
      }, {
        type: 1,
        value: "discount"
      }, {
        type: 0,
        value: "%)"
      }]
    },
    processing_fee_caption: {
      id: "price_summary.processing_fee_caption",
      defaultMessage: [{
        type: 0,
        value: "Peerspace's processing fee and applicable taxes will be calculated in checkout."
      }]
    },
    attendee_count: {
      id: "price_summary.attendee_count",
      defaultMessage: [{
        type: 0,
        value: "For "
      }, {
        type: 1,
        value: "attendeeCount"
      }, {
        type: 0,
        value: " guests"
      }]
    },
    total_before_taxes: {
      id: "price_summary.total_before_taxes",
      defaultMessage: [{
        type: 0,
        value: "Est. total before taxes"
      }]
    },
    pay_now_pay_later: {
      id: "price_summary.pay_now_pay_later",
      defaultMessage: [{
        type: 0,
        value: "Pay part now, part later available in checkout"
      }]
    },
    total_label: {
      id: "price_summary.total_label",
      defaultMessage: [{
        type: 0,
        value: "Total"
      }]
    },
    available_in_checkout_copy: {
      id: "price_summary.available_in_checkout_copy",
      defaultMessage: [{
        type: 0,
        value: "available in checkout"
      }]
    },
    hour_label: {
      id: "price_summary.hour_label",
      defaultMessage: [{
        type: 0,
        value: "hour"
      }]
    },
    hourly_price_discount_modification: {
      id: "price_summary.hourly_price_discount_modification",
      defaultMessage: [{
        type: 0,
        value: "8+ hour discount ("
      }, {
        type: 1,
        value: "pctDiscount"
      }, {
        type: 0,
        value: "%)"
      }]
    },
    hourly_price_discount_label: {
      id: "price_summary.hourly_price_discount_label",
      defaultMessage: [{
        type: 0,
        value: "8+ hour discount"
      }]
    },
    hourly_price_tier_modification: {
      id: "price_summary.hourly_price_tier_modification",
      defaultMessage: [{
        type: 0,
        value: "Hourly price for "
      }, {
        type: 1,
        value: "tier"
      }, {
        type: 0,
        value: " guests"
      }]
    },
    hourly_price_tier_modification_default: {
      id: "price_summary.hourly_price_tier_modification_default",
      defaultMessage: [{
        type: 0,
        value: "For "
      }, {
        type: 1,
        value: "tier"
      }, {
        type: 0,
        value: " guests"
      }]
    },
    pay_part_now_copy: {
      id: "price_summary.pay_part_now_copy",
      defaultMessage: [{
        type: 0,
        value: "Pay part now, part later"
      }]
    },
    processing_fee_label: {
      id: "price_summary.processing_fee_label",
      defaultMessage: [{
        type: 0,
        value: "Processing fee"
      }]
    },
    before_taxes_label: {
      id: "price_summary.before_taxes_label",
      defaultMessage: [{
        type: 0,
        value: "before taxes"
      }]
    }
  }),
  [_.BUTTON]: i({
    submit: {
      id: "button.submit",
      defaultMessage: [{
        type: 0,
        value: "Submit"
      }]
    }
  }),
  [_.FOOTER]: O,
  [_.LOCALE_SELECTOR]: i({
    header: {
      id: "shared_component.language_country_selector.header",
      defaultMessage: [{
        type: 0,
        value: "Customize your experience"
      }]
    },
    subheader: {
      id: "shared_component.language_country_selector.subheader",
      defaultMessage: [{
        type: 0,
        value: "Set your preferred language and region"
      }]
    },
    error_msg: {
      id: "shared_component.language_country_selector.error_msg",
      defaultMessage: [{
        type: 0,
        value: "Unknown error occurred. Please try again."
      }]
    }
  }),
  [_.NAVIGATION]: y,
  [_.NAVBAR_BROWSE_PATHS]: M,
  [_.NAVBAR_BROWSE_PATHS_ACTIVITIES]: v,
  [_.NAVBAR_BROWSE_PATHS_AMENITIES]: T,
  [_.NAVBAR_BROWSE_PATHS_LOCATIONS]: I,
  [_.NAVBAR_BROWSE_PATHS_IDEAS]: R,
  [_.NAVBAR_BROWSE_PATHS_SPACE_TYPES]: c,
  [_.NAVBAR_BROWSE_PATHS_VENDORS]: N
};
export {
  t as A,
  _ as C,
  s as F,
  l as I,
  e as L,
  a as N,
  r as S,
  d as V,
  n as a,
  o as b,
  f as u
};
//# sourceMappingURL=IntlGlobalMessages.DP29fCHC.js.map
